import React, {useEffect, useState} from "react";
import {Autocomplete, Button, Checkbox, TextField, Typography, useMediaQuery} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import {useTranslation} from "react-i18next";

const icon = <CheckBoxOutlineBlankIcon fontSize="small"/>;
const checkedIcon = <CheckBoxIcon fontSize="small"/>;

export default function CheckboxesTags({
                                           data,
                                           addQuestion,
                                           deleteQuestionsAfterIndex,
                                           goToNextQuestion,
                                           isVisible,
                                           addToUpdateQuestions,
                                           deleteFromQuestionToUpdate,
                                       }) {
    const isMobile = useMediaQuery("(max-width:900px)");
    const [selectedValues, setSelectedValues] = useState(data?.currentValue || []);
    const [showError, setShowError] = useState(false);
    const {t} = useTranslation();
    const language = localStorage.getItem("i18nextLng");

    // Load initial values from data.currentValue
    useEffect(() => {
        if (data?.groupedData && data?.currentValue) {
            const groupedValues = Object.values(data?.currentValue).flat(); // Flatten grouped data into a single array
            setSelectedValues(groupedValues);
        }
    }, [data]);

    useEffect(() => {
        if ((data.key === "WebApp_programming_F" || data.key === "WebApp_CMS_F") && data?.currentValue) {
            addToUpdateQuestions(data, selectedValues);
        }
    }, [data, selectedValues])

    // Handle changes when tags are selected or deselected
    const onTagsChange = (event, values) => {
        deleteQuestionsAfterIndex(data);
        deleteFromQuestionToUpdate(data);
        const selected = values.map((el) => el.value);
        setSelectedValues(selected);

        if (data.required && selected.length === 0) {
            setShowError(true);
        } else {
            setShowError(false);
        }
    };

    // Handle the "Next" button click
    const handleNextClick = () => {
        if (data && selectedValues && selectedValues !== data.currentValue) {
            addToUpdateQuestions(data, selectedValues);
        }

        if (data?.question_object) {
            // If the question_object type is "multiTags", update its choices
            if (data?.question_object?.type === "multiTags" && data?.question_object?.key === "critical_personal_data_list_E") {
                // Map selectedValues to the corresponding choice objects from data.choices
                const selectedChoices = data.choices.filter((choice) =>
                    selectedValues.includes(choice.value)
                );
                data.question_object.choices = selectedChoices;
            }
            addQuestion(data.question_object); // Add the modified question_object
        } else {
            // Otherwise, move to the next question
            goToNextQuestion();
        }
    };

    function handleSkipClick() {
        if (data?.associated_step_id === "4c2ea3bd-831a-4a53-8cc7-5ec1b26d628b") {
            if (data?.question_object) {

                addQuestion(data?.question_object);
            } else {
                // Otherwise, move to the next question
                goToNextQuestion(null, true);
            }
        } else {
            goToNextQuestion(null, true);
        }
    }

    return (
        <div style={{padding: "20px"}}>
            {/* Question */}
            <Typography variant="subtitle1" sx={{mb: 2}}>
                {language === "fr" ? data?.question_fr : data.question}
            </Typography>

            {/* Autocomplete */}
            <Autocomplete
                value={data.choices.filter((el) => selectedValues.includes(el.value))} // Preselect values
                multiple
                options={data.choices}
                disableCloseOnSelect
                groupBy={(option) => t(option.category)} // Group by category
                getOptionLabel={(option) => t(option.value)} // Show value labels
                onChange={onTagsChange} // Update values on change
                renderOption={(props, option, {selected}) => (
                    <li {...props}>
                        <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{marginRight: 8}}
                            checked={selected}
                        />
                        {t(option.value)}
                    </li>
                )}
                renderInput={(params) => (
                    <TextField {...params} label={t(data.label)} placeholder={t("Select options")}/>
                )}
            />

            {/* Error Message */}
            {showError && <span style={{color: "red"}}>{t("This field is required")}</span>}


            <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                {isVisible(data) && (
                    <Button
                        variant="contained"
                        color="secondary"
                        style={{
                            height: "50px",
                            width: data?.associated_step_id !== "4c2ea3bd-831a-4a53-8cc7-5ec1b26d628b" ? "50%" : "50%", // Each button takes 45% of the container width
                            marginTop: "20px",
                        }}
                        onClick={handleNextClick}
                        disabled={selectedValues.length === 0} // Disable if required fields are empty
                    >
                        {data?.last_step_question_2 ? t("finish") : t("next")}
                    </Button>
                )}
                {isVisible(data) && (
                    <Button
                        style={{
                            height: "50px",
                            width: "50%", // Each button takes 45% of the container width
                            marginTop: "20px",
                        }}
                        color="secondary"
                        variant="contained"
                        onClick={handleSkipClick}
                    >
                        {t("skip")}
                    </Button>
                )}
            </div>

        </div>
    );
}
